import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { QrCodesPage } from '@/features/marketing/qr-codes';
import { formatDocumentTitle } from '@/lib/document-title';

/** Marketing › QR Codes — a permanent, ready-made code for every flyer destination. */
export const Route = createFileRoute('/_auth/$orgId/marketing/qr-codes')({
  component: QrCodesRoute,
});

function QrCodesRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('QR Codes', 'Marketing')}</title>
      </Helmet>
      <QrCodesPage routeOrgId={orgId} />
    </>
  );
}
